$(document).ready(function () {
  FastClick.attach(document.body);

  // Prevent click focus underlines
  $(document).on('mouseup', 'a, a *, button, button *, h3', function () {
    if (this.tagName == 'BUTTON' || this.tagName == 'A' || this.tagName == 'H3') {
      $(this).blur();
    }
  });

  // Startup
  FastClick.attach(document.body);
});

$('document').ready(function () {
  FastClick.attach(document.body);
});
